import React from 'react'
import PropTypes from 'prop-types'
import accountUtils from '../../../utils/account/accountUtils'

const ImpersonationBanner = props => accountUtils.isImpersonating(props.user) ? (
  <div
    style={{
      top: 0,
      left: 0,
      right: 0,
      backgroundColor: '#39bbd2',
      textAlign: 'center',
      padding: 10,
      color: 'white'
    }}
  >
    You are impersonating {accountUtils.getFullName(props.user)}
  </div>
) : null

ImpersonationBanner.propTypes = {
  user: PropTypes.any,
}

export default ImpersonationBanner



// WEBPACK FOOTER //
// ./src/components/ui/notifications/ImpersonationBanner.js